/**
 * Brand scope for the staff shell (brands build plan §4.6), on the generated `MeOut.brands` / `MeOut.brand_scope`
 * and `PATCH /me/notifications {brand_scope}` shapes from brands-visibility-queue (#1445).
 * Owner: web-brand-shell.
 */
import { unwrap } from '../../lib/api/client'
import { type BrandSummary, type MeOut, type NotificationPrefsOut, patchPrefsApiV1MeNotificationsPatch } from '../../lib/api/generated'

export type { BrandSummary }

/** The slice of `MeOut` the brand shell reads. */
export type BrandScopedMe = Pick<MeOut, 'brands' | 'brand_scope'>

/** Same pattern as the API's `NotificationPrefsIn.brand_scope`. */
export const BRAND_SLUG = /^[a-z][a-z0-9_]{1,40}$/

export function validBrandScope(value: unknown): string | undefined {
  return typeof value === 'string' && (value === 'all' || BRAND_SLUG.test(value)) ? value : undefined
}

/** Save the queue's brand as the person's `brand_scope` (the generated client adds the CSRF header). */
export function patchBrandScope(brandScope: string): Promise<NotificationPrefsOut> {
  return unwrap(patchPrefsApiV1MeNotificationsPatch({ body: { brand_scope: brandScope } }))
}
